ixModuleRouting("impactx.securitydata", {
    "/securitydata/:userId": {
        template: "<ixa-security-data></ixa-security-data>",
        templateUrl: "modules/securitydata/templates/security-data.html",
        controller: "SecurityDataCtrl",
        controllerAs: "securityDataCtrl",
        process: "SecurityData",
        workspace: "system",
    },
});
